import { render } from "./CxSecondaryDataPanel.vue?vue&type=template&id=a9ed2b34"
import script from "./CxSecondaryDataPanel.vue?vue&type=script&lang=js"
export * from "./CxSecondaryDataPanel.vue?vue&type=script&lang=js"

import "./CxSecondaryDataPanel.vue?vue&type=style&index=0&id=a9ed2b34&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__